/*@flow*/
import * as I from 'immutable';
import type { StateT } from './types';

const initState = {
  mode: 'READY',
  geojsonType: 'Point',
  fullAddress: '',
  fullAddressFromProps: '',
  theGeom: null,
  theGeomOrig: null,
  center: null,
  centerOrig: null,
  schema: I.Map(),
  decks: I.Map(),
  drawingHandler: null,
  name: 'project[address]',
  theGeomName: 'project[the_geom]',
  onAddressChange: _ => _,
  onGeomChange: _ => _,
};

const mkState: I.RecordFactory<StateT> = I.Record(initState, 'State');
export default mkState;
